import * as Types from './actionTypes';

export const approveShipper = (id) => ({
  type: Types.APPROVE_SHIPPER,
  payload: {
    id,
  },
});

export const approveDriver = (id) => ({
  type: Types.APPROVE_DRIVER,
  payload: {
    id,
  },
});

export const declineShipper = (id) => ({
  type: Types.DECLINE_SHIPPER,
  payload: {
    id,
  },
});

export const declineDriver = (id) => ({
  type: Types.DECLINE_DRIVER,
  payload: {
    id,
  },
});

export const makeOperator = (id) => ({
  type: Types.MAKE_OPERATOR,
  payload: {
    id,
  },
});

export const revokeOperator = (id) => ({
  type: Types.REVOKE_OPERATOR,
  payload: {
    id,
  },
});

export const makeAccountAdmin = (id) => ({
  type: Types.MAKE_ACCOUNT_ADMIN,
  payload: {
    id,
  },
});

export const revokeAccountAdmin = (id) => ({
  type: Types.REVOKE_ACCOUNT_ADMIN,
  payload: {
    id,
  },
});

export const refreshShippers = () => ({
  type: Types.REFRESH_SHIPPERS,
});

export const refreshDrivers = () => ({
  type: Types.REFRESH_DRIVERS,
});

export const refreshShipments = () => ({
  type: Types.REFRESH_SHIPMENTS,
});

export const makeFinanceAdmin = (id) => ({
  type: Types.MAKE_FINANCE_ADMIN,
  payload: {
    id,
  },
});
export const makeFleetAdmin = (id) => ({
  type: Types.MAKE_FLEET_ADMIN,
  payload: {
    id,
  },
});

export const revokeFinanceAdmin = (id) => ({
  type: Types.REVOKE_FINANCE_ADMIN,
  payload: {
    id,
  },
});

export const makeProfile = (id, role) => ({
  type: Types.MAKE_PROFILE,
  payload: {
    id,
    role,
  },
});

export const makeProfileDone = (id, role, grantedProfileId) => ({
  type: Types.MAKE_PROFILE_DONE,
  payload: {
    id,
    role,
    grantedProfileId,
  },
});

export const revokeProfile = (id, role) => ({
  type: Types.REVOKE_PROFILE,
  payload: {
    id,
    role,
  },
});

export const revokeProfileDone = (id, role) => ({
  type: Types.REVOKE_PROFILE_DONE,
  payload: {
    id,
    role,
  },
});

export const activateProfile = (id, role) => ({
  type: Types.ACTIVATE_PROFILE,
  payload: {
    id,
    role,
  },
});

export const activateProfileDone = (id, role) => ({
  type: Types.ACTIVATE_PROFILE_DONE,
  payload: {
    id,
    role,
  },
});
export const profileActivated = (id, type) => ({
  type: Types.PROFILE_ACTIVATED,
  payload: {
    id,
    type,
  },
});

export const profileSuspended = (id, type) => ({
  type: Types.PROFILE_SUSPENDED,
  payload: {
    id,
    type,
  },
});

export const driverMadeAvailable = (id) => ({
  type: Types.DRIVER_MADE_AVAILABLE,
  payload: {
    id,
  },
});

export const driverMadeUnavailable = (id) => ({
  type: Types.DRIVER_MADE_UNAVAILABLE,
  payload: {
    id,
  },
});
